import axios from 'axios'

const getApiBaseUrl = () =>
  (process.env.REACT_APP_LOCAL_API_URL || '').trim().replace(/\/+$/, '')

const apiClient = axios.create({
  timeout: 30000,
})

export const callGet = (url, token, params = {}, byPassAuthorization = '', responseType = '') => {
  const headers = {}

  if (token) {
    headers.authorization = `Bearer ${token}`
  }
  if (byPassAuthorization) {
    headers.byPassAuthorization = `${byPassAuthorization}`
  }
  return apiClient.get(`${getApiBaseUrl()}${url}`, {
    headers,
    params,
    responseType,
  })
}

export const callPost = (url, payload, token = '', byPassAuthorization = '', contentType = '', timeoutMs = 0) => {
  const headers = {}

  if (token) {
    headers.authorization = `Bearer ${token}`
  }
  if (byPassAuthorization) {
    headers.byPassAuthorization = `${byPassAuthorization}`
  }
  if (contentType) {
    headers['Content-Type'] = `${contentType}`
  }
  return axios.post(`${getApiBaseUrl()}${url}`, payload, {
    headers,
    ...(timeoutMs > 0 ? { timeout: timeoutMs } : {}),
  })
}